export default __webpack_public_path__ + "static/background-e35052273324906b16c7a754d9b8ce80.jpg";